import { profiles } from "../contexts/constants/profiles";

/**
 * Ruta inicial según el rol del usuario. Centraliza la lógica que antes estaba embebida en el login,
 * para reutilizarla también tras la selección de país.
 */
export const getHomeRouteByRole = (role: string): string => {
  if (role === profiles[0].name) return "/proyectos";        // Director de proyectos
  if (role === profiles[1].name) return "/personal";         // Control de Obras
  if (role === profiles[2].name) return "/usuarios";         // Gerente
  if (role === profiles[3].name) return "/control-produccion"; // Visualizador
  return "/control-produccion";                              // Administrativo / por defecto
};
